var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),(_vm.logado)?_c('search-psychologist-component',{attrs:{"footer":true}}):_vm._e(),(_vm.logado)?_c('footer-page'):_vm._e(),_c('login-modal',{ref:"loginModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }